
riot.tag2('person-pricetype-select-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Тип цены</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="form-group col-sm-12 {has-error: error.parentName}">\n          <label class="control-label">Выберите тип цены</label>\n          <div class="input-group" style="width: 100%;">\n            <select class="form-control" name="priceType">\n              <option each="{priceTypeTitle}" value="{id}" __selected="{id == item.priceType}" no-reorder>{name}</option>\n            </select>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.on('mount', function () {
    var modal = self.tags['bs-modal'];
    modal.item = {};
    modal.item.priceType = 0;
    modal.priceTypeTitle = [{ id: 0, name: 'Розничная' }, { id: 1, name: 'Корпоративная' }, { id: 2, name: 'Оптовая' }];

    modal.mixin('change');
});
});


// WEBPACK FOOTER //
// ./pages/persons/person-pricetype-select-modal.tag